module.exports = __webpack_public_path__ + "6febf1a040e493906123766b692fb48d.jpg";